(function ($, Drupal) {

  // Sidenav navigation JS
  Drupal.behaviors.initEcommerceTray = {
    attach: function (context, settings) {

      $('.ecommerce--A', context).once('initEcommerceTray').each(function () {

        let $commerceBlock = $(this),
          $title = $('.lifestyle__product-title').text(),
          $bundleTitle = $commerceBlock.find('.ecommerce__heading .field__item').length !== 0 ? $commerceBlock.find('.ecommerce__heading .field__item').text() : null,
          $commerceBLock = $(this),
          $body = $('body'),
          $window = $(window),
          $wrapper = $('.wrapper'),
          $btn = '',
          $html = '',
          $flag = false;

        // TODO: make plugin + extend before/after states
        $.fn.isInViewport = function () {

          let $this = $(this),
            elementTop = $this.offset().top,
            elementBottom = elementTop + $this.outerHeight(),
            viewportTop = $window.scrollTop(),
            viewportBottom = viewportTop + $window.height();

          return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        function setupTray() {
          if (!$flag) {
            $flag = true;
            $btn = $commerceBlock.find('.ecommerce__data .form-actions input').val() ? $commerceBlock.find('.ecommerce__data .form-actions input').val() : $commerceBlock.find('.ecommerce__data .form-submit').text();

            if ($btn) {
              if ($title) {
                $html = '<div class="ecommerce__tray"><div class="ecommerce__tray-wrap"><div class="ecommerce__tray-name">' + $title + '</div><div class="ecommerce__tray-button"><span class="btn btn--B">' + $btn + '</span></div></div></div>';
              } else if($bundleTitle) {
                $html = '<div class="ecommerce__tray"><div class="ecommerce__tray-wrap"><div class="ecommerce__tray-name">' + $bundleTitle + '</div><div class="ecommerce__tray-button"><span class="btn btn--B">' + $btn + '</span></div></div></div>';
              } else {
                $html = '<div class="ecommerce__tray"><div class="ecommerce__tray-wrap"><div class="ecommerce__tray-name"></div><div class="ecommerce__tray-button"><span class="btn btn--B">' + $btn + '</span></div></div></div>';
              }
            } else {
              $html = '<div class="ecommerce__tray disabled"></div>';
            }

            $body.append($html);

            $('.ecommerce__tray .btn').on('click', function(e) {

              if($('.form-radios').length) {
                e.preventDefault();

                $('html, body').animate({
                  scrollTop: $('.ecommerce--A').offset().top
                }, 300);
              }
              else if ($('.ecommerce.ecommerce--bundle').length) {
                if ($('.buy-now-button input.btn').length) {
                  $('.buy-now-button input.btn').mousedown();
                } else {
                  $('.buy-now-button a.btn').click();
                }
              }
              else {
                $('div[id^="commerce-product-add-to-cart-form"] .btn').mousedown();
              }
            });
          }
        }

        function checkWindow() {

          setupTray();

          const $tray = $('.ecommerce__tray');

          if (!$tray.hasClass('disabled')) {
            if ($commerceBLock.isInViewport()) {
              $tray.removeClass('is-active');
              $wrapper.removeClass('tray-active');
            } else {
              $tray.addClass('is-active');
              $wrapper.addClass('tray-active');
            }
          }
        }

        const trigger = throttle((e) => {
          checkWindow();
        }, 300);

        $window.on({
          scroll: function () {
            trigger();
          },
        });

      });

    }
  };

})(jQuery, Drupal);


